export default "__VITE_ASSET__CfmILAt0__"